import { render, staticRenderFns } from "./DatabaseStep.vue?vue&type=template&id=16bb88db&"
import script from "./DatabaseStep.vue?vue&type=script&lang=ts&"
export * from "./DatabaseStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports